import get from 'lodash/get';
import * as companyPageActions from '../../action_creators/mic/company_page_action_creators';
import log from '../../../services/logger_service';

import tagAllFeedActions from '../tag/async_tag_all_feed_actions';
import companyActions from './async_company_actions';
import companyAwardsActions from './async_company_awards_actions';
import companyDataActions from './async_company_data_actions';

import asyncRecircFeedActions from '../async_recirc_feed_actions';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';

export default function fetchCompanyPage(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(companyPageActions.companyPageLoading({}, store));
    return Promise.all([
      companyActions(params, store)(dispatch),
      companyDataActions(params, store)(dispatch),
      companyAwardsActions(params, store)(dispatch),
      tagAllFeedActions(params, store, true)(dispatch),
      asyncRecircFeedActions(params, store)(dispatch)
    ])
      .then(function handlePostDetailData() {
        dispatch(companyPageActions.companyPageLoaded({}, store));
        return true;
      })
      .catch(function handleUserError(err) {
        const status = get(err, 'response.status') || 500;
        if (status === 404) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        } else {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
          log.error(err, `Error in tag page actions, message: ${err.message}`);
        }
        dispatch(companyPageActions.companyPageLoadError(err, store));
      });
  };
}
